import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import SmallButton from '@/components/buttons/SmallButton.vue'
import IxRouterLink from '@/components/navigation/IxRouterLink.vue'
import snippets from '@/content/snippets.js'
import constants from '@/constants.js'
import langs from '@/data/langs'
import ixrouter from '@/components/navigation/ixrouter.js'
import kk from '@/constants.js'
import Vue2TouchEvents from 'vue2-touch-events'
import loadScript from 'load-script2'
import apix from '@/api.js'

let gscript = null
//let zohoScript = null
let baiduScript = null

Vue.use(Vue2TouchEvents)

Vue.component('small-button', SmallButton)
Vue.component('ix-router-link', IxRouterLink)
Vue.prototype.$nippets = snippets
Vue.prototype.$k = constants
Vue.prototype.$ixr = ixrouter
Vue.prototype.$apix = apix

let loadHandled = false

function getUtmParams(to) {
  if(to.query) {
    let utms = null
    if(to.query.utm_source) {
      utms = {}
      utms.utm_source =  to.query.utm_source
      if(to.query.utm_campaign) {
        utms.utm_campaign = to.query.utm_campaign
      }
      if(to.query.utm_medium) {
        utms.utm_medium = to.query.utm_medium
      }
    }
    if(utms) {
      store.commit('setUtms', utms)
    }
  }
  if(store.state.referer === null) {
    if(document.referrer) {
      let r = document.referrer
      if(r !== '') {
        if(r.indexOf('illustrationx.com') < 0) {
          store.commit('setReferer', r)
        }
      }
    }
  }
}

// only gets called once
function handleLoad(to) {
  loadHandled = true
  //loadZoho()
  getUtmParams(to)
}

async function loadGoogleScript(to) {
  if(gscript === null){
    try {
      gscript = await loadScript('https://www.googletagmanager.com/gtag/js?id=UA-2304493-2')
    }
    catch(err){
      console.log(err)
    }
  }
  if(!window.gtag){
    window.dataLayer = window.dataLayer || [];
    window.gtag = function (){
      window.dataLayer.push(arguments);
    }
    window.gtag('js', new Date());
  }
  window.gtag('config', 'UA-2304493-2', {'page_path': to.path});
  window.uetq = window.uetq || [];
  window.uetq.push('event', 'page_view', { page_path: to.path }); 
}

async function loadBaidu() {
  if(baiduScript === null)
  {
    try {
      baiduScript = await loadScript('https://hm.baidu.com/hm.js?a69b449c7b9c4d04dadf6a895e01a809')
    }
    catch(err) {
      console.log(err)
    }
  }
}

/*
async function loadZoho() {
  if(zohoScript === null)
  {
    try {
      zohoScript = await loadScript('https://cdn-in.pagesense.io/js/illustrationx/59362cd45eea4d9a9556b4bbe46c2c6e.js')
    }
    catch(err) {
      console.log(err)
    }
  }
}
*/

async function loadGoogle(to) {
  if(store.state.lang !== 'CN'){
    loadGoogleScript(to)
  }
  else {
    loadBaidu()
  }
  if(!constants.isBot()) {
    setTimeout(() => {
      let un = '-'
      if(store.state.profile) {
        un = store.state.profile.username
      }
      let ua = navigator.userAgent
      apix.post('events/vzdt', { vzid: store.getters.visitorId, sxid: store.getters.sessionId, pt: to.path,
        geo: store.state.lang, utm: store.state.utms, referer: store.state.referer, user: un, user_agent: ua
      })
    }, 500)
  }
  if(!loadHandled) {
    handleLoad(to)
  }
  await constants.waitfor(500)
}

function setCanonical(to) {
  let cnc = document.querySelector('#cnc')
  if(cnc) {
    cnc.rel = 'canonical'
    cnc.href = 'https://www.illustrationx.com' + to.path
  }
}

router.beforeEach((to, from, next) => {
  store.commit('setFromPage', from.path)
  kk.setMetatags('IllustrationX','')
  if((to.path.indexOf('not-found') < 0) || ((to.path.indexOf('notfound.html')) < 0)){
    setCanonical(to)
    if(to.params.lang) {
      if(!langs.navlangs.includes(to.params.lang)){
        let path = ixrouter.path
        if(!store.state.langPref) {
          store.commit('setLang', 'UK')
        }
        next(path)
        return
      }
      else {
        if(!store.state.langPref){
          store.commit('setLang', to.params.lang.toUpperCase())
        }
      }
    }
    else {
      let lang = ixrouter.getLangFromPath(to.path)
      if(!store.state.langPref) {
        store.commit('setLang', lang)
      }
      else {
        store.commit('setLang', store.state.langPref)
      }
    }
  }
  loadGoogle(to)
  next()
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
